import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "login-auth-wrapper" }
const _hoisted_2 = { class: "layout-login" }
const _hoisted_3 = { class: "layout-login-inner" }
const _hoisted_4 = { class: "layout-login__footer" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { class: "login-auth-wrapper-release-sign" }

import {
  ITirPmUserLoginRequest,
  ITirUserResponse,
} from "@/tir-pm-authenticator/src/interfaces";
import { TirPmAutentificatiorService } from "@/tir-pm-authenticator";
import { useRoute, useRouter } from "vue-router";
import AuthLayout from "@/layouts/AuthLayout.vue";
import {
  UserIcon,
  KeyIcon,
  EyeIcon,
  EyeSlashIcon,
} from "tir-style-system/icons/outline";
import { TirPmInput } from "tir-pm-input";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";
import { TirDivider } from "tir-pm-divider";
import { computed, onBeforeUpdate, onMounted, ref, watch } from "vue";

/**
 * Дата для копирайта
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  setup(__props) {

let today = new Date();
let year = today.getFullYear();

const route = useRoute();
/**
 * Дата для копирайта
 */

/**
 * Текущий элемент
 */
const $curentPageComponentAuth = ref(null);

/**
 * Метод для кнопки
 */
const computedMethodFromComponentRoute = computed(
  () => $curentPageComponentAuth.value?.changerMethodFromComponent
);

/**
 * Текущая высота компонента
 */
const currentHeightComponent = computed(() => {
  return $curentPageComponentAuth.value?.currentHeightComponent / 16;
});

/**
 * Состояние лоудинга в компоненте
 */
const isLoadingStateComponentComputed = computed(() => {
  return $curentPageComponentAuth.value?.isLoadingIntoComponent;
});

/**
 * Высчитать высоту блока
 */
const computeStyleHeight = computed(() => {
  return currentHeightComponent.value
    ? currentHeightComponent.value + "rem"
    : "9.375rem";
});
console.log("Имя", route.name);

/**
 * Дизейбл кнопки
 */
const isDisabledButtonFromComponent = computed(
  () => $curentPageComponentAuth.value?.validateMainButton
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_Transition, {
              name: "change-login-page",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  ref_key: "$curentPageComponentAuth",
                  ref: $curentPageComponentAuth
                }, null, 512))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(TirPmButton), {
          size: _unref(TirPmButtonSizeEnum).Regular,
          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
          style: {"width":"100%"},
          class: "layout-login-main-button",
          onClick: computedMethodFromComponentRoute.value,
          isDisabled: isDisabledButtonFromComponent.value,
          isLoading: isLoadingStateComponentComputed.value,
          test: "login-btn"
        }, {
          default: _withCtx(() => [
            _createVNode(_Transition, {
              name: "button-slide",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_unref(route).name == 'login')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Войти"))
                  : (_unref(route).name == 'restore-access')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Восстановить доступ"))
                    : (_unref(route).name == 'restore-password')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Сохранить и войти"))
                      : (_unref(route).name == 'restore-done')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Вернуться к авторизации"))
                        : (_unref(route).name == 'activate-account')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Войти"))
                          : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["size", "variant", "onClick", "isDisabled", "isLoading"]),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["layout-login__footer-additional-button", {
            'layout-login__footer-additional-button--show':
              _unref(route).name == 'login',
          }])
        }, [
          _createVNode(_component_router_link, { to: "/restore-access" }, {
            default: _withCtx(() => [
              _createVNode(_unref(TirPmButton), {
                size: _unref(TirPmButtonSizeEnum).Regular,
                variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                style: {"width":"100%"},
                test: "restore-access-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Восстановить доступ ")
                ]),
                _: 1
              }, 8, ["size", "variant"])
            ]),
            _: 1
          })
        ], 2), [
          [_vShow, _unref(route).name == 'login']
        ])
      ])
    ]),
    _createElementVNode("span", _hoisted_10, "© 2010 - " + _toDisplayString(_unref(year)) + " TirScript. All rights reserved. Images copyright.", 1)
  ]))
}
}

})